import AttachMoneyIcon from 'components/material-symbol/icons/AttachMoney'
import GroupIcon from 'components/material-symbol/icons/Group'
import PlaylistAddCheckIcon from 'components/material-symbol/icons/PlaylistAddCheck'
import EventAvailableIcon from 'components/material-symbol/icons/EventAvailable'
import LibraryBooksIcon from 'components/material-symbol/icons/LibraryBooks'
import GolfCourseIcon from 'components/material-symbol/icons/GolfCourse'
import NotificationsActiveIcon from 'components/material-symbol/icons/NotificationsActive'
import { ReactComponent as AutoRespondersIcon } from 'images/icons/auto-responders.svg'

export const RECOMMENDED_STEP_ICONS = {
  AttachMoney: AttachMoneyIcon,
  Group: GroupIcon,
  PlaylistAddCheck: PlaylistAddCheckIcon,
  EventAvailable: EventAvailableIcon,
  LibraryBooks: LibraryBooksIcon,
  GolfCourse: GolfCourseIcon,
  NotificationsActive: NotificationsActiveIcon,
  AutoResponders: AutoRespondersIcon,
}

export const getRecommendedStepIcon = iconName =>
  RECOMMENDED_STEP_ICONS[iconName] || null
